const LANGUAGES = {
  hse: [
    { value: 'cn', label: '中文' },
    { value: 'en', label: 'English' },
    { value: 'es', label: 'Español' },
    { value: 'fr', label: 'Français' },
    { value: 'pt', label: 'Português' },
    //{ value: 'ar', label: 'Arabic' },
  ],
  sse: [
    { value: 'cn', label: '中文' },
    { value: 'en', label: 'English' },
    { value: 'fr', label: 'Français' },
  ],
  cvd: [{ value: 'en', label: 'English' }],
};

export default LANGUAGES;
